// source: scout/candidate/v1/candidate.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.scout.candidate.v1.Activity', null, global);
goog.exportSymbol('proto.scout.candidate.v1.BulkVoteUpRequest', null, global);
goog.exportSymbol('proto.scout.candidate.v1.BulkVoteUpResponse', null, global);
goog.exportSymbol('proto.scout.candidate.v1.CandidateLastAccessRange', null, global);
goog.exportSymbol('proto.scout.candidate.v1.CandidateSearchOption', null, global);
goog.exportSymbol('proto.scout.candidate.v1.CandidateSortKey', null, global);
goog.exportSymbol('proto.scout.candidate.v1.CandidateSortOrder', null, global);
goog.exportSymbol('proto.scout.candidate.v1.CandidateUser', null, global);
goog.exportSymbol('proto.scout.candidate.v1.CareerVision', null, global);
goog.exportSymbol('proto.scout.candidate.v1.CoreOfJobHunting', null, global);
goog.exportSymbol('proto.scout.candidate.v1.CountForAgentRequest', null, global);
goog.exportSymbol('proto.scout.candidate.v1.CountForAgentResponse', null, global);
goog.exportSymbol('proto.scout.candidate.v1.CountRequest', null, global);
goog.exportSymbol('proto.scout.candidate.v1.CountResponse', null, global);
goog.exportSymbol('proto.scout.candidate.v1.CreateSearchOptionRequest', null, global);
goog.exportSymbol('proto.scout.candidate.v1.CreateSearchOptionResponse', null, global);
goog.exportSymbol('proto.scout.candidate.v1.DeleteSearchOptionRequest', null, global);
goog.exportSymbol('proto.scout.candidate.v1.DeleteSearchOptionResponse', null, global);
goog.exportSymbol('proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest', null, global);
goog.exportSymbol('proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse', null, global);
goog.exportSymbol('proto.scout.candidate.v1.GetScoutCandidateDetailRequest', null, global);
goog.exportSymbol('proto.scout.candidate.v1.GetScoutCandidateDetailResponse', null, global);
goog.exportSymbol('proto.scout.candidate.v1.GetSearchOptionRequest', null, global);
goog.exportSymbol('proto.scout.candidate.v1.GetSearchOptionResponse', null, global);
goog.exportSymbol('proto.scout.candidate.v1.InternshipResult', null, global);
goog.exportSymbol('proto.scout.candidate.v1.LanguageAbility', null, global);
goog.exportSymbol('proto.scout.candidate.v1.Profile', null, global);
goog.exportSymbol('proto.scout.candidate.v1.ProgrammingSkill', null, global);
goog.exportSymbol('proto.scout.candidate.v1.ResearchContent', null, global);
goog.exportSymbol('proto.scout.candidate.v1.SavedCandidateSearchOption', null, global);
goog.exportSymbol('proto.scout.candidate.v1.SavedCandidateSearchOptionDetail', null, global);
goog.exportSymbol('proto.scout.candidate.v1.ScoutCandidateDetail', null, global);
goog.exportSymbol('proto.scout.candidate.v1.SearchForAgentRequest', null, global);
goog.exportSymbol('proto.scout.candidate.v1.SearchForAgentResponse', null, global);
goog.exportSymbol('proto.scout.candidate.v1.SearchRequest', null, global);
goog.exportSymbol('proto.scout.candidate.v1.SearchResponse', null, global);
goog.exportSymbol('proto.scout.candidate.v1.SelfPromotion', null, global);
goog.exportSymbol('proto.scout.candidate.v1.StudentEndeavor', null, global);
goog.exportSymbol('proto.scout.candidate.v1.UpdateSearchOptionNameRequest', null, global);
goog.exportSymbol('proto.scout.candidate.v1.UpdateSearchOptionNameResponse', null, global);
goog.exportSymbol('proto.scout.candidate.v1.UpdateSearchOptionRequest', null, global);
goog.exportSymbol('proto.scout.candidate.v1.UpdateSearchOptionResponse', null, global);
goog.exportSymbol('proto.scout.candidate.v1.VoteDownRequest', null, global);
goog.exportSymbol('proto.scout.candidate.v1.VoteDownResponse', null, global);
goog.exportSymbol('proto.scout.candidate.v1.VoteUpRequest', null, global);
goog.exportSymbol('proto.scout.candidate.v1.VoteUpResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.CandidateSearchOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.scout.candidate.v1.CandidateSearchOption.repeatedFields_, null);
};
goog.inherits(proto.scout.candidate.v1.CandidateSearchOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.CandidateSearchOption.displayName = 'proto.scout.candidate.v1.CandidateSearchOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.CountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.CountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.CountRequest.displayName = 'proto.scout.candidate.v1.CountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.SearchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.SearchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.SearchRequest.displayName = 'proto.scout.candidate.v1.SearchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.VoteUpRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.VoteUpRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.VoteUpRequest.displayName = 'proto.scout.candidate.v1.VoteUpRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.VoteDownRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.VoteDownRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.VoteDownRequest.displayName = 'proto.scout.candidate.v1.VoteDownRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.BulkVoteUpRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.scout.candidate.v1.BulkVoteUpRequest.repeatedFields_, null);
};
goog.inherits(proto.scout.candidate.v1.BulkVoteUpRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.BulkVoteUpRequest.displayName = 'proto.scout.candidate.v1.BulkVoteUpRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.GetScoutCandidateDetailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.GetScoutCandidateDetailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.GetScoutCandidateDetailRequest.displayName = 'proto.scout.candidate.v1.GetScoutCandidateDetailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.CandidateUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.scout.candidate.v1.CandidateUser.repeatedFields_, null);
};
goog.inherits(proto.scout.candidate.v1.CandidateUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.CandidateUser.displayName = 'proto.scout.candidate.v1.CandidateUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.SearchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.scout.candidate.v1.SearchResponse.repeatedFields_, null);
};
goog.inherits(proto.scout.candidate.v1.SearchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.SearchResponse.displayName = 'proto.scout.candidate.v1.SearchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.CountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.CountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.CountResponse.displayName = 'proto.scout.candidate.v1.CountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.VoteUpResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.VoteUpResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.VoteUpResponse.displayName = 'proto.scout.candidate.v1.VoteUpResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.BulkVoteUpResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.BulkVoteUpResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.BulkVoteUpResponse.displayName = 'proto.scout.candidate.v1.BulkVoteUpResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.VoteDownResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.VoteDownResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.VoteDownResponse.displayName = 'proto.scout.candidate.v1.VoteDownResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.GetScoutCandidateDetailResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.GetScoutCandidateDetailResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.GetScoutCandidateDetailResponse.displayName = 'proto.scout.candidate.v1.GetScoutCandidateDetailResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.CreateSearchOptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.CreateSearchOptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.CreateSearchOptionRequest.displayName = 'proto.scout.candidate.v1.CreateSearchOptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.CreateSearchOptionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.CreateSearchOptionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.CreateSearchOptionResponse.displayName = 'proto.scout.candidate.v1.CreateSearchOptionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.ScoutCandidateDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.scout.candidate.v1.ScoutCandidateDetail.repeatedFields_, null);
};
goog.inherits(proto.scout.candidate.v1.ScoutCandidateDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.ScoutCandidateDetail.displayName = 'proto.scout.candidate.v1.ScoutCandidateDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.Profile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.Profile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.Profile.displayName = 'proto.scout.candidate.v1.Profile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.CoreOfJobHunting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.scout.candidate.v1.CoreOfJobHunting.repeatedFields_, null);
};
goog.inherits(proto.scout.candidate.v1.CoreOfJobHunting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.CoreOfJobHunting.displayName = 'proto.scout.candidate.v1.CoreOfJobHunting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.Activity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.Activity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.Activity.displayName = 'proto.scout.candidate.v1.Activity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.InternshipResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.InternshipResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.InternshipResult.displayName = 'proto.scout.candidate.v1.InternshipResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.ProgrammingSkill = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.ProgrammingSkill, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.ProgrammingSkill.displayName = 'proto.scout.candidate.v1.ProgrammingSkill';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.LanguageAbility = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.LanguageAbility, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.LanguageAbility.displayName = 'proto.scout.candidate.v1.LanguageAbility';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.StudentEndeavor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.StudentEndeavor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.StudentEndeavor.displayName = 'proto.scout.candidate.v1.StudentEndeavor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.SelfPromotion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.SelfPromotion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.SelfPromotion.displayName = 'proto.scout.candidate.v1.SelfPromotion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.ResearchContent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.ResearchContent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.ResearchContent.displayName = 'proto.scout.candidate.v1.ResearchContent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.CareerVision = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.CareerVision, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.CareerVision.displayName = 'proto.scout.candidate.v1.CareerVision';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.SavedCandidateSearchOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.SavedCandidateSearchOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.SavedCandidateSearchOption.displayName = 'proto.scout.candidate.v1.SavedCandidateSearchOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest.displayName = 'proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.repeatedFields_, null);
};
goog.inherits(proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.displayName = 'proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.GetSearchOptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.GetSearchOptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.GetSearchOptionRequest.displayName = 'proto.scout.candidate.v1.GetSearchOptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.SavedCandidateSearchOptionDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.SavedCandidateSearchOptionDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.displayName = 'proto.scout.candidate.v1.SavedCandidateSearchOptionDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.GetSearchOptionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.GetSearchOptionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.GetSearchOptionResponse.displayName = 'proto.scout.candidate.v1.GetSearchOptionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.UpdateSearchOptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.UpdateSearchOptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.UpdateSearchOptionRequest.displayName = 'proto.scout.candidate.v1.UpdateSearchOptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.UpdateSearchOptionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.UpdateSearchOptionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.UpdateSearchOptionResponse.displayName = 'proto.scout.candidate.v1.UpdateSearchOptionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.UpdateSearchOptionNameRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.UpdateSearchOptionNameRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.UpdateSearchOptionNameRequest.displayName = 'proto.scout.candidate.v1.UpdateSearchOptionNameRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.UpdateSearchOptionNameResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.UpdateSearchOptionNameResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.UpdateSearchOptionNameResponse.displayName = 'proto.scout.candidate.v1.UpdateSearchOptionNameResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.DeleteSearchOptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.DeleteSearchOptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.DeleteSearchOptionRequest.displayName = 'proto.scout.candidate.v1.DeleteSearchOptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.DeleteSearchOptionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.DeleteSearchOptionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.DeleteSearchOptionResponse.displayName = 'proto.scout.candidate.v1.DeleteSearchOptionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.SearchForAgentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.SearchForAgentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.SearchForAgentRequest.displayName = 'proto.scout.candidate.v1.SearchForAgentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.SearchForAgentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.scout.candidate.v1.SearchForAgentResponse.repeatedFields_, null);
};
goog.inherits(proto.scout.candidate.v1.SearchForAgentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.SearchForAgentResponse.displayName = 'proto.scout.candidate.v1.SearchForAgentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.CountForAgentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.CountForAgentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.CountForAgentRequest.displayName = 'proto.scout.candidate.v1.CountForAgentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scout.candidate.v1.CountForAgentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scout.candidate.v1.CountForAgentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scout.candidate.v1.CountForAgentResponse.displayName = 'proto.scout.candidate.v1.CountForAgentResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.scout.candidate.v1.CandidateSearchOption.repeatedFields_ = [4,5,8,10,11,12,13,15,16,17,18,19,20,25,26,27,29,30];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.CandidateSearchOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.CandidateSearchOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CandidateSearchOption.toObject = function(includeInstance, msg) {
  var f, obj = {
voterUserOnly: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
votedUserOnly: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
lineIdExists: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
gradesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
graduateYearsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
subscribeToInfoForWomen: (f = jspb.Message.getBooleanField(msg, 6)) == null ? undefined : f,
uniqueId: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
universityAreaIdsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
universityNamesList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
departmentNamesList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
concentrationNamesList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
coursesList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
highSchoolName: (f = jspb.Message.getField(msg, 14)) == null ? undefined : f,
aspiringBusinessCategoryIdsList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f,
internshipResultCompanyNamesList: (f = jspb.Message.getRepeatedField(msg, 16)) == null ? undefined : f,
activityLargeCategoryNamesList: (f = jspb.Message.getRepeatedField(msg, 17)) == null ? undefined : f,
activityMediumCategoryNamesList: (f = jspb.Message.getRepeatedField(msg, 18)) == null ? undefined : f,
programmingSkillNamesList: (f = jspb.Message.getRepeatedField(msg, 19)) == null ? undefined : f,
programmingSkillYearOfUsesList: (f = jspb.Message.getRepeatedField(msg, 20)) == null ? undefined : f,
lastAccessRangeKey: jspb.Message.getFieldWithDefault(msg, 21, 0),
keywordForUniversityOrDepartmentName: (f = jspb.Message.getField(msg, 22)) == null ? undefined : f,
studentEndeavorExists: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
selfPromotionExists: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
preferredWorkPrefectureIdsList: (f = jspb.Message.getRepeatedField(msg, 25)) == null ? undefined : f,
preferredJobTypeIdsList: (f = jspb.Message.getRepeatedField(msg, 26)) == null ? undefined : f,
companyChoiceFactorTypeIdsList: (f = jspb.Message.getRepeatedField(msg, 27)) == null ? undefined : f,
internshipResultExists: jspb.Message.getBooleanFieldWithDefault(msg, 28, false),
languageAbilityNamesList: (f = jspb.Message.getRepeatedField(msg, 29)) == null ? undefined : f,
languageAbilityLevelsList: (f = jspb.Message.getRepeatedField(msg, 30)) == null ? undefined : f,
researchContentExists: jspb.Message.getBooleanFieldWithDefault(msg, 31, false),
keywordForLikeSearch: (f = jspb.Message.getField(msg, 32)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption}
 */
proto.scout.candidate.v1.CandidateSearchOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.CandidateSearchOption;
  return proto.scout.candidate.v1.CandidateSearchOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.CandidateSearchOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption}
 */
proto.scout.candidate.v1.CandidateSearchOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVoterUserOnly(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVotedUserOnly(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLineIdExists(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addGrades(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addGraduateYears(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSubscribeToInfoForWomen(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUniqueId(value);
      break;
    case 8:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addUniversityAreaIds(values[i]);
      }
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addUniversityNames(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addDepartmentNames(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addConcentrationNames(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addCourses(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setHighSchoolName(value);
      break;
    case 15:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAspiringBusinessCategoryIds(values[i]);
      }
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.addInternshipResultCompanyNames(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.addActivityLargeCategoryNames(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.addActivityMediumCategoryNames(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.addProgrammingSkillNames(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.addProgrammingSkillYearOfUses(value);
      break;
    case 21:
      var value = /** @type {!proto.scout.candidate.v1.CandidateLastAccessRange} */ (reader.readEnum());
      msg.setLastAccessRangeKey(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeywordForUniversityOrDepartmentName(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStudentEndeavorExists(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSelfPromotionExists(value);
      break;
    case 25:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPreferredWorkPrefectureIds(values[i]);
      }
      break;
    case 26:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPreferredJobTypeIds(values[i]);
      }
      break;
    case 27:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCompanyChoiceFactorTypeIds(values[i]);
      }
      break;
    case 28:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInternshipResultExists(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.addLanguageAbilityNames(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.addLanguageAbilityLevels(value);
      break;
    case 31:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setResearchContentExists(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeywordForLikeSearch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.CandidateSearchOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.CandidateSearchOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CandidateSearchOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVoterUserOnly();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getVotedUserOnly();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getLineIdExists();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getGradesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getGraduateYearsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUniversityAreaIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      8,
      f
    );
  }
  f = message.getUniversityNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getDepartmentNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = message.getConcentrationNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
  f = message.getCoursesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getAspiringBusinessCategoryIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      15,
      f
    );
  }
  f = message.getInternshipResultCompanyNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      16,
      f
    );
  }
  f = message.getActivityLargeCategoryNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      17,
      f
    );
  }
  f = message.getActivityMediumCategoryNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      18,
      f
    );
  }
  f = message.getProgrammingSkillNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      19,
      f
    );
  }
  f = message.getProgrammingSkillYearOfUsesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      20,
      f
    );
  }
  f = message.getLastAccessRangeKey();
  if (f !== 0.0) {
    writer.writeEnum(
      21,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getStudentEndeavorExists();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getSelfPromotionExists();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getPreferredWorkPrefectureIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      25,
      f
    );
  }
  f = message.getPreferredJobTypeIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      26,
      f
    );
  }
  f = message.getCompanyChoiceFactorTypeIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      27,
      f
    );
  }
  f = message.getInternshipResultExists();
  if (f) {
    writer.writeBool(
      28,
      f
    );
  }
  f = message.getLanguageAbilityNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      29,
      f
    );
  }
  f = message.getLanguageAbilityLevelsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      30,
      f
    );
  }
  f = message.getResearchContentExists();
  if (f) {
    writer.writeBool(
      31,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 32));
  if (f != null) {
    writer.writeString(
      32,
      f
    );
  }
};


/**
 * optional bool voter_user_only = 1;
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getVoterUserOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setVoterUserOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool voted_user_only = 2;
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getVotedUserOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setVotedUserOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool line_id_exists = 3;
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getLineIdExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setLineIdExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated string grades = 4;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getGradesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setGradesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addGrades = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearGradesList = function() {
  return this.setGradesList([]);
};


/**
 * repeated string graduate_years = 5;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getGraduateYearsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setGraduateYearsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addGraduateYears = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearGraduateYearsList = function() {
  return this.setGraduateYearsList([]);
};


/**
 * optional bool subscribe_to_info_for_women = 6;
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getSubscribeToInfoForWomen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setSubscribeToInfoForWomen = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearSubscribeToInfoForWomen = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.hasSubscribeToInfoForWomen = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string unique_id = 7;
 * @return {string}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getUniqueId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setUniqueId = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearUniqueId = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.hasUniqueId = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * repeated int64 university_area_ids = 8;
 * @return {!Array<number>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getUniversityAreaIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setUniversityAreaIdsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addUniversityAreaIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearUniversityAreaIdsList = function() {
  return this.setUniversityAreaIdsList([]);
};


/**
 * repeated string university_names = 10;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getUniversityNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setUniversityNamesList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addUniversityNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearUniversityNamesList = function() {
  return this.setUniversityNamesList([]);
};


/**
 * repeated string department_names = 11;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getDepartmentNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setDepartmentNamesList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addDepartmentNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearDepartmentNamesList = function() {
  return this.setDepartmentNamesList([]);
};


/**
 * repeated string concentration_names = 12;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getConcentrationNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setConcentrationNamesList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addConcentrationNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearConcentrationNamesList = function() {
  return this.setConcentrationNamesList([]);
};


/**
 * repeated string courses = 13;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getCoursesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setCoursesList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addCourses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearCoursesList = function() {
  return this.setCoursesList([]);
};


/**
 * optional string high_school_name = 14;
 * @return {string}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getHighSchoolName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setHighSchoolName = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearHighSchoolName = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.hasHighSchoolName = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * repeated int64 aspiring_business_category_ids = 15;
 * @return {!Array<number>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getAspiringBusinessCategoryIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 15));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setAspiringBusinessCategoryIdsList = function(value) {
  return jspb.Message.setField(this, 15, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addAspiringBusinessCategoryIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearAspiringBusinessCategoryIdsList = function() {
  return this.setAspiringBusinessCategoryIdsList([]);
};


/**
 * repeated string internship_result_company_names = 16;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getInternshipResultCompanyNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 16));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setInternshipResultCompanyNamesList = function(value) {
  return jspb.Message.setField(this, 16, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addInternshipResultCompanyNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 16, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearInternshipResultCompanyNamesList = function() {
  return this.setInternshipResultCompanyNamesList([]);
};


/**
 * repeated string activity_large_category_names = 17;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getActivityLargeCategoryNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 17));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setActivityLargeCategoryNamesList = function(value) {
  return jspb.Message.setField(this, 17, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addActivityLargeCategoryNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 17, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearActivityLargeCategoryNamesList = function() {
  return this.setActivityLargeCategoryNamesList([]);
};


/**
 * repeated string activity_medium_category_names = 18;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getActivityMediumCategoryNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 18));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setActivityMediumCategoryNamesList = function(value) {
  return jspb.Message.setField(this, 18, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addActivityMediumCategoryNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 18, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearActivityMediumCategoryNamesList = function() {
  return this.setActivityMediumCategoryNamesList([]);
};


/**
 * repeated string programming_skill_names = 19;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getProgrammingSkillNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 19));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setProgrammingSkillNamesList = function(value) {
  return jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addProgrammingSkillNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearProgrammingSkillNamesList = function() {
  return this.setProgrammingSkillNamesList([]);
};


/**
 * repeated string programming_skill_year_of_uses = 20;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getProgrammingSkillYearOfUsesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 20));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setProgrammingSkillYearOfUsesList = function(value) {
  return jspb.Message.setField(this, 20, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addProgrammingSkillYearOfUses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 20, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearProgrammingSkillYearOfUsesList = function() {
  return this.setProgrammingSkillYearOfUsesList([]);
};


/**
 * optional CandidateLastAccessRange last_access_range_key = 21;
 * @return {!proto.scout.candidate.v1.CandidateLastAccessRange}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getLastAccessRangeKey = function() {
  return /** @type {!proto.scout.candidate.v1.CandidateLastAccessRange} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.scout.candidate.v1.CandidateLastAccessRange} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setLastAccessRangeKey = function(value) {
  return jspb.Message.setProto3EnumField(this, 21, value);
};


/**
 * optional string keyword_for_university_or_department_name = 22;
 * @return {string}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getKeywordForUniversityOrDepartmentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setKeywordForUniversityOrDepartmentName = function(value) {
  return jspb.Message.setField(this, 22, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearKeywordForUniversityOrDepartmentName = function() {
  return jspb.Message.setField(this, 22, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.hasKeywordForUniversityOrDepartmentName = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional bool student_endeavor_exists = 23;
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getStudentEndeavorExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setStudentEndeavorExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool self_promotion_exists = 24;
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getSelfPromotionExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setSelfPromotionExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * repeated int64 preferred_work_prefecture_ids = 25;
 * @return {!Array<number>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getPreferredWorkPrefectureIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 25));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setPreferredWorkPrefectureIdsList = function(value) {
  return jspb.Message.setField(this, 25, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addPreferredWorkPrefectureIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 25, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearPreferredWorkPrefectureIdsList = function() {
  return this.setPreferredWorkPrefectureIdsList([]);
};


/**
 * repeated int64 preferred_job_type_ids = 26;
 * @return {!Array<number>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getPreferredJobTypeIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 26));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setPreferredJobTypeIdsList = function(value) {
  return jspb.Message.setField(this, 26, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addPreferredJobTypeIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 26, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearPreferredJobTypeIdsList = function() {
  return this.setPreferredJobTypeIdsList([]);
};


/**
 * repeated int64 company_choice_factor_type_ids = 27;
 * @return {!Array<number>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getCompanyChoiceFactorTypeIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 27));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setCompanyChoiceFactorTypeIdsList = function(value) {
  return jspb.Message.setField(this, 27, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addCompanyChoiceFactorTypeIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 27, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearCompanyChoiceFactorTypeIdsList = function() {
  return this.setCompanyChoiceFactorTypeIdsList([]);
};


/**
 * optional bool internship_result_exists = 28;
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getInternshipResultExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 28, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setInternshipResultExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 28, value);
};


/**
 * repeated string language_ability_names = 29;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getLanguageAbilityNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 29));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setLanguageAbilityNamesList = function(value) {
  return jspb.Message.setField(this, 29, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addLanguageAbilityNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 29, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearLanguageAbilityNamesList = function() {
  return this.setLanguageAbilityNamesList([]);
};


/**
 * repeated string language_ability_levels = 30;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getLanguageAbilityLevelsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 30));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setLanguageAbilityLevelsList = function(value) {
  return jspb.Message.setField(this, 30, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.addLanguageAbilityLevels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 30, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearLanguageAbilityLevelsList = function() {
  return this.setLanguageAbilityLevelsList([]);
};


/**
 * optional bool research_content_exists = 31;
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getResearchContentExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 31, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setResearchContentExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 31, value);
};


/**
 * optional string keyword_for_like_search = 32;
 * @return {string}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.getKeywordForLikeSearch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.setKeywordForLikeSearch = function(value) {
  return jspb.Message.setField(this, 32, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.scout.candidate.v1.CandidateSearchOption} returns this
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.clearKeywordForLikeSearch = function() {
  return jspb.Message.setField(this, 32, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateSearchOption.prototype.hasKeywordForLikeSearch = function() {
  return jspb.Message.getField(this, 32) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.CountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.CountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.CountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
searchOption: (f = msg.getSearchOption()) && proto.scout.candidate.v1.CandidateSearchOption.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.CountRequest}
 */
proto.scout.candidate.v1.CountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.CountRequest;
  return proto.scout.candidate.v1.CountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.CountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.CountRequest}
 */
proto.scout.candidate.v1.CountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.scout.candidate.v1.CandidateSearchOption;
      reader.readMessage(value,proto.scout.candidate.v1.CandidateSearchOption.deserializeBinaryFromReader);
      msg.setSearchOption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.CountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.CountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.CountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSearchOption();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.scout.candidate.v1.CandidateSearchOption.serializeBinaryToWriter
    );
  }
};


/**
 * optional CandidateSearchOption search_option = 1;
 * @return {?proto.scout.candidate.v1.CandidateSearchOption}
 */
proto.scout.candidate.v1.CountRequest.prototype.getSearchOption = function() {
  return /** @type{?proto.scout.candidate.v1.CandidateSearchOption} */ (
    jspb.Message.getWrapperField(this, proto.scout.candidate.v1.CandidateSearchOption, 1));
};


/**
 * @param {?proto.scout.candidate.v1.CandidateSearchOption|undefined} value
 * @return {!proto.scout.candidate.v1.CountRequest} returns this
*/
proto.scout.candidate.v1.CountRequest.prototype.setSearchOption = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scout.candidate.v1.CountRequest} returns this
 */
proto.scout.candidate.v1.CountRequest.prototype.clearSearchOption = function() {
  return this.setSearchOption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.CountRequest.prototype.hasSearchOption = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.SearchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.SearchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.SearchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.SearchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
searchOption: (f = msg.getSearchOption()) && proto.scout.candidate.v1.CandidateSearchOption.toObject(includeInstance, f),
sortKey: jspb.Message.getFieldWithDefault(msg, 2, 0),
sortOrder: jspb.Message.getFieldWithDefault(msg, 3, 0),
page: jspb.Message.getFieldWithDefault(msg, 4, 0),
per: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.SearchRequest}
 */
proto.scout.candidate.v1.SearchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.SearchRequest;
  return proto.scout.candidate.v1.SearchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.SearchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.SearchRequest}
 */
proto.scout.candidate.v1.SearchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.scout.candidate.v1.CandidateSearchOption;
      reader.readMessage(value,proto.scout.candidate.v1.CandidateSearchOption.deserializeBinaryFromReader);
      msg.setSearchOption(value);
      break;
    case 2:
      var value = /** @type {!proto.scout.candidate.v1.CandidateSortKey} */ (reader.readEnum());
      msg.setSortKey(value);
      break;
    case 3:
      var value = /** @type {!proto.scout.candidate.v1.CandidateSortOrder} */ (reader.readEnum());
      msg.setSortOrder(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.SearchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.SearchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.SearchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.SearchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSearchOption();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.scout.candidate.v1.CandidateSearchOption.serializeBinaryToWriter
    );
  }
  f = message.getSortKey();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSortOrder();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getPer();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional CandidateSearchOption search_option = 1;
 * @return {?proto.scout.candidate.v1.CandidateSearchOption}
 */
proto.scout.candidate.v1.SearchRequest.prototype.getSearchOption = function() {
  return /** @type{?proto.scout.candidate.v1.CandidateSearchOption} */ (
    jspb.Message.getWrapperField(this, proto.scout.candidate.v1.CandidateSearchOption, 1));
};


/**
 * @param {?proto.scout.candidate.v1.CandidateSearchOption|undefined} value
 * @return {!proto.scout.candidate.v1.SearchRequest} returns this
*/
proto.scout.candidate.v1.SearchRequest.prototype.setSearchOption = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scout.candidate.v1.SearchRequest} returns this
 */
proto.scout.candidate.v1.SearchRequest.prototype.clearSearchOption = function() {
  return this.setSearchOption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.SearchRequest.prototype.hasSearchOption = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CandidateSortKey sort_key = 2;
 * @return {!proto.scout.candidate.v1.CandidateSortKey}
 */
proto.scout.candidate.v1.SearchRequest.prototype.getSortKey = function() {
  return /** @type {!proto.scout.candidate.v1.CandidateSortKey} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.scout.candidate.v1.CandidateSortKey} value
 * @return {!proto.scout.candidate.v1.SearchRequest} returns this
 */
proto.scout.candidate.v1.SearchRequest.prototype.setSortKey = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional CandidateSortOrder sort_order = 3;
 * @return {!proto.scout.candidate.v1.CandidateSortOrder}
 */
proto.scout.candidate.v1.SearchRequest.prototype.getSortOrder = function() {
  return /** @type {!proto.scout.candidate.v1.CandidateSortOrder} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.scout.candidate.v1.CandidateSortOrder} value
 * @return {!proto.scout.candidate.v1.SearchRequest} returns this
 */
proto.scout.candidate.v1.SearchRequest.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 page = 4;
 * @return {number}
 */
proto.scout.candidate.v1.SearchRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.SearchRequest} returns this
 */
proto.scout.candidate.v1.SearchRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 per = 5;
 * @return {number}
 */
proto.scout.candidate.v1.SearchRequest.prototype.getPer = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.SearchRequest} returns this
 */
proto.scout.candidate.v1.SearchRequest.prototype.setPer = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.VoteUpRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.VoteUpRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.VoteUpRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.VoteUpRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.VoteUpRequest}
 */
proto.scout.candidate.v1.VoteUpRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.VoteUpRequest;
  return proto.scout.candidate.v1.VoteUpRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.VoteUpRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.VoteUpRequest}
 */
proto.scout.candidate.v1.VoteUpRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.VoteUpRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.VoteUpRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.VoteUpRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.VoteUpRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 user_id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.VoteUpRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.VoteUpRequest} returns this
 */
proto.scout.candidate.v1.VoteUpRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.VoteDownRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.VoteDownRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.VoteDownRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.VoteDownRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.VoteDownRequest}
 */
proto.scout.candidate.v1.VoteDownRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.VoteDownRequest;
  return proto.scout.candidate.v1.VoteDownRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.VoteDownRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.VoteDownRequest}
 */
proto.scout.candidate.v1.VoteDownRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.VoteDownRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.VoteDownRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.VoteDownRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.VoteDownRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 user_id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.VoteDownRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.VoteDownRequest} returns this
 */
proto.scout.candidate.v1.VoteDownRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.scout.candidate.v1.BulkVoteUpRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.BulkVoteUpRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.BulkVoteUpRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.BulkVoteUpRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.BulkVoteUpRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.BulkVoteUpRequest}
 */
proto.scout.candidate.v1.BulkVoteUpRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.BulkVoteUpRequest;
  return proto.scout.candidate.v1.BulkVoteUpRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.BulkVoteUpRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.BulkVoteUpRequest}
 */
proto.scout.candidate.v1.BulkVoteUpRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addUserIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.BulkVoteUpRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.BulkVoteUpRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.BulkVoteUpRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.BulkVoteUpRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      1,
      f
    );
  }
};


/**
 * repeated int64 user_ids = 1;
 * @return {!Array<number>}
 */
proto.scout.candidate.v1.BulkVoteUpRequest.prototype.getUserIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.scout.candidate.v1.BulkVoteUpRequest} returns this
 */
proto.scout.candidate.v1.BulkVoteUpRequest.prototype.setUserIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.BulkVoteUpRequest} returns this
 */
proto.scout.candidate.v1.BulkVoteUpRequest.prototype.addUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.BulkVoteUpRequest} returns this
 */
proto.scout.candidate.v1.BulkVoteUpRequest.prototype.clearUserIdsList = function() {
  return this.setUserIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.GetScoutCandidateDetailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.GetScoutCandidateDetailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.GetScoutCandidateDetailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.GetScoutCandidateDetailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.GetScoutCandidateDetailRequest}
 */
proto.scout.candidate.v1.GetScoutCandidateDetailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.GetScoutCandidateDetailRequest;
  return proto.scout.candidate.v1.GetScoutCandidateDetailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.GetScoutCandidateDetailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.GetScoutCandidateDetailRequest}
 */
proto.scout.candidate.v1.GetScoutCandidateDetailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.GetScoutCandidateDetailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.GetScoutCandidateDetailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.GetScoutCandidateDetailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.GetScoutCandidateDetailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 user_id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.GetScoutCandidateDetailRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.GetScoutCandidateDetailRequest} returns this
 */
proto.scout.candidate.v1.GetScoutCandidateDetailRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.scout.candidate.v1.CandidateUser.repeatedFields_ = [11,12,14,15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.CandidateUser.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.CandidateUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.CandidateUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CandidateUser.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
uniqueId: jspb.Message.getFieldWithDefault(msg, 2, ""),
universityName: jspb.Message.getFieldWithDefault(msg, 3, ""),
course: jspb.Message.getFieldWithDefault(msg, 4, ""),
department: jspb.Message.getFieldWithDefault(msg, 5, ""),
concentration: jspb.Message.getFieldWithDefault(msg, 6, ""),
grade: jspb.Message.getFieldWithDefault(msg, 7, ""),
graduateYear: jspb.Message.getFieldWithDefault(msg, 8, ""),
lastAccessAtMs: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
voted: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
aspiringBusinessCategoriesList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
internshipResultCompanyNamesList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
studentEndeavor: (f = jspb.Message.getField(msg, 13)) == null ? undefined : f,
preferredWorkPrefecturesList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
preferredJobTypesList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f,
selfPromotion: (f = jspb.Message.getField(msg, 16)) == null ? undefined : f,
seminarCircle: jspb.Message.getFieldWithDefault(msg, 17, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.CandidateUser}
 */
proto.scout.candidate.v1.CandidateUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.CandidateUser;
  return proto.scout.candidate.v1.CandidateUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.CandidateUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.CandidateUser}
 */
proto.scout.candidate.v1.CandidateUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUniqueId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUniversityName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCourse(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartment(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setConcentration(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setGrade(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setGraduateYear(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastAccessAtMs(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVoted(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addAspiringBusinessCategories(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addInternshipResultCompanyNames(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setStudentEndeavor(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addPreferredWorkPrefectures(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.addPreferredJobTypes(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSelfPromotion(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeminarCircle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.CandidateUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.CandidateUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.CandidateUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CandidateUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUniqueId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUniversityName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCourse();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDepartment();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getConcentration();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getGrade();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getGraduateYear();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getVoted();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getAspiringBusinessCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = message.getInternshipResultCompanyNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPreferredWorkPrefecturesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
  f = message.getPreferredJobTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      15,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getSeminarCircle();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
};


/**
 * optional int64 user_id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string unique_id = 2;
 * @return {string}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getUniqueId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setUniqueId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string university_name = 3;
 * @return {string}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getUniversityName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setUniversityName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string course = 4;
 * @return {string}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getCourse = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setCourse = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string department = 5;
 * @return {string}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getDepartment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setDepartment = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string concentration = 6;
 * @return {string}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getConcentration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setConcentration = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string grade = 7;
 * @return {string}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getGrade = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setGrade = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string graduate_year = 8;
 * @return {string}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getGraduateYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setGraduateYear = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 last_access_at_ms = 9;
 * @return {number}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getLastAccessAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setLastAccessAtMs = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.clearLastAccessAtMs = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateUser.prototype.hasLastAccessAtMs = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool voted = 10;
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getVoted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setVoted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * repeated string aspiring_business_categories = 11;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getAspiringBusinessCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setAspiringBusinessCategoriesList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.addAspiringBusinessCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.clearAspiringBusinessCategoriesList = function() {
  return this.setAspiringBusinessCategoriesList([]);
};


/**
 * repeated string internship_result_company_names = 12;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getInternshipResultCompanyNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setInternshipResultCompanyNamesList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.addInternshipResultCompanyNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.clearInternshipResultCompanyNamesList = function() {
  return this.setInternshipResultCompanyNamesList([]);
};


/**
 * optional string student_endeavor = 13;
 * @return {string}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getStudentEndeavor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setStudentEndeavor = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.clearStudentEndeavor = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateUser.prototype.hasStudentEndeavor = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * repeated string preferred_work_prefectures = 14;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getPreferredWorkPrefecturesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setPreferredWorkPrefecturesList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.addPreferredWorkPrefectures = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.clearPreferredWorkPrefecturesList = function() {
  return this.setPreferredWorkPrefecturesList([]);
};


/**
 * repeated string preferred_job_types = 15;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getPreferredJobTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 15));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setPreferredJobTypesList = function(value) {
  return jspb.Message.setField(this, 15, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.addPreferredJobTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.clearPreferredJobTypesList = function() {
  return this.setPreferredJobTypesList([]);
};


/**
 * optional string self_promotion = 16;
 * @return {string}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getSelfPromotion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setSelfPromotion = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.clearSelfPromotion = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.CandidateUser.prototype.hasSelfPromotion = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string seminar_circle = 17;
 * @return {string}
 */
proto.scout.candidate.v1.CandidateUser.prototype.getSeminarCircle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CandidateUser} returns this
 */
proto.scout.candidate.v1.CandidateUser.prototype.setSeminarCircle = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.scout.candidate.v1.SearchResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.SearchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.SearchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.SearchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.SearchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
usersList: jspb.Message.toObjectList(msg.getUsersList(),
    proto.scout.candidate.v1.CandidateUser.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.SearchResponse}
 */
proto.scout.candidate.v1.SearchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.SearchResponse;
  return proto.scout.candidate.v1.SearchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.SearchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.SearchResponse}
 */
proto.scout.candidate.v1.SearchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.scout.candidate.v1.CandidateUser;
      reader.readMessage(value,proto.scout.candidate.v1.CandidateUser.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.SearchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.SearchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.SearchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.SearchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.scout.candidate.v1.CandidateUser.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CandidateUser users = 1;
 * @return {!Array<!proto.scout.candidate.v1.CandidateUser>}
 */
proto.scout.candidate.v1.SearchResponse.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.scout.candidate.v1.CandidateUser>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.scout.candidate.v1.CandidateUser, 1));
};


/**
 * @param {!Array<!proto.scout.candidate.v1.CandidateUser>} value
 * @return {!proto.scout.candidate.v1.SearchResponse} returns this
*/
proto.scout.candidate.v1.SearchResponse.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.scout.candidate.v1.CandidateUser=} opt_value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateUser}
 */
proto.scout.candidate.v1.SearchResponse.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.scout.candidate.v1.CandidateUser, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.SearchResponse} returns this
 */
proto.scout.candidate.v1.SearchResponse.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.CountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.CountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.CountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
count: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.CountResponse}
 */
proto.scout.candidate.v1.CountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.CountResponse;
  return proto.scout.candidate.v1.CountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.CountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.CountResponse}
 */
proto.scout.candidate.v1.CountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.CountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.CountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.CountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 count = 1;
 * @return {number}
 */
proto.scout.candidate.v1.CountResponse.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.CountResponse} returns this
 */
proto.scout.candidate.v1.CountResponse.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.VoteUpResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.VoteUpResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.VoteUpResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.VoteUpResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.VoteUpResponse}
 */
proto.scout.candidate.v1.VoteUpResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.VoteUpResponse;
  return proto.scout.candidate.v1.VoteUpResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.VoteUpResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.VoteUpResponse}
 */
proto.scout.candidate.v1.VoteUpResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.VoteUpResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.VoteUpResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.VoteUpResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.VoteUpResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.BulkVoteUpResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.BulkVoteUpResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.BulkVoteUpResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.BulkVoteUpResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.BulkVoteUpResponse}
 */
proto.scout.candidate.v1.BulkVoteUpResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.BulkVoteUpResponse;
  return proto.scout.candidate.v1.BulkVoteUpResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.BulkVoteUpResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.BulkVoteUpResponse}
 */
proto.scout.candidate.v1.BulkVoteUpResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.BulkVoteUpResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.BulkVoteUpResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.BulkVoteUpResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.BulkVoteUpResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.VoteDownResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.VoteDownResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.VoteDownResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.VoteDownResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.VoteDownResponse}
 */
proto.scout.candidate.v1.VoteDownResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.VoteDownResponse;
  return proto.scout.candidate.v1.VoteDownResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.VoteDownResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.VoteDownResponse}
 */
proto.scout.candidate.v1.VoteDownResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.VoteDownResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.VoteDownResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.VoteDownResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.VoteDownResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.GetScoutCandidateDetailResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.GetScoutCandidateDetailResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.GetScoutCandidateDetailResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.GetScoutCandidateDetailResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
scoutCandidateDetail: (f = msg.getScoutCandidateDetail()) && proto.scout.candidate.v1.ScoutCandidateDetail.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.GetScoutCandidateDetailResponse}
 */
proto.scout.candidate.v1.GetScoutCandidateDetailResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.GetScoutCandidateDetailResponse;
  return proto.scout.candidate.v1.GetScoutCandidateDetailResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.GetScoutCandidateDetailResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.GetScoutCandidateDetailResponse}
 */
proto.scout.candidate.v1.GetScoutCandidateDetailResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.scout.candidate.v1.ScoutCandidateDetail;
      reader.readMessage(value,proto.scout.candidate.v1.ScoutCandidateDetail.deserializeBinaryFromReader);
      msg.setScoutCandidateDetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.GetScoutCandidateDetailResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.GetScoutCandidateDetailResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.GetScoutCandidateDetailResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.GetScoutCandidateDetailResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScoutCandidateDetail();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.scout.candidate.v1.ScoutCandidateDetail.serializeBinaryToWriter
    );
  }
};


/**
 * optional ScoutCandidateDetail scout_candidate_detail = 1;
 * @return {?proto.scout.candidate.v1.ScoutCandidateDetail}
 */
proto.scout.candidate.v1.GetScoutCandidateDetailResponse.prototype.getScoutCandidateDetail = function() {
  return /** @type{?proto.scout.candidate.v1.ScoutCandidateDetail} */ (
    jspb.Message.getWrapperField(this, proto.scout.candidate.v1.ScoutCandidateDetail, 1));
};


/**
 * @param {?proto.scout.candidate.v1.ScoutCandidateDetail|undefined} value
 * @return {!proto.scout.candidate.v1.GetScoutCandidateDetailResponse} returns this
*/
proto.scout.candidate.v1.GetScoutCandidateDetailResponse.prototype.setScoutCandidateDetail = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scout.candidate.v1.GetScoutCandidateDetailResponse} returns this
 */
proto.scout.candidate.v1.GetScoutCandidateDetailResponse.prototype.clearScoutCandidateDetail = function() {
  return this.setScoutCandidateDetail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.GetScoutCandidateDetailResponse.prototype.hasScoutCandidateDetail = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.CreateSearchOptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.CreateSearchOptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.CreateSearchOptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CreateSearchOptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
searchOption: (f = msg.getSearchOption()) && proto.scout.candidate.v1.CandidateSearchOption.toObject(includeInstance, f),
searchOptionName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.CreateSearchOptionRequest}
 */
proto.scout.candidate.v1.CreateSearchOptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.CreateSearchOptionRequest;
  return proto.scout.candidate.v1.CreateSearchOptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.CreateSearchOptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.CreateSearchOptionRequest}
 */
proto.scout.candidate.v1.CreateSearchOptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.scout.candidate.v1.CandidateSearchOption;
      reader.readMessage(value,proto.scout.candidate.v1.CandidateSearchOption.deserializeBinaryFromReader);
      msg.setSearchOption(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchOptionName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.CreateSearchOptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.CreateSearchOptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.CreateSearchOptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CreateSearchOptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSearchOption();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.scout.candidate.v1.CandidateSearchOption.serializeBinaryToWriter
    );
  }
  f = message.getSearchOptionName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional CandidateSearchOption search_option = 1;
 * @return {?proto.scout.candidate.v1.CandidateSearchOption}
 */
proto.scout.candidate.v1.CreateSearchOptionRequest.prototype.getSearchOption = function() {
  return /** @type{?proto.scout.candidate.v1.CandidateSearchOption} */ (
    jspb.Message.getWrapperField(this, proto.scout.candidate.v1.CandidateSearchOption, 1));
};


/**
 * @param {?proto.scout.candidate.v1.CandidateSearchOption|undefined} value
 * @return {!proto.scout.candidate.v1.CreateSearchOptionRequest} returns this
*/
proto.scout.candidate.v1.CreateSearchOptionRequest.prototype.setSearchOption = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scout.candidate.v1.CreateSearchOptionRequest} returns this
 */
proto.scout.candidate.v1.CreateSearchOptionRequest.prototype.clearSearchOption = function() {
  return this.setSearchOption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.CreateSearchOptionRequest.prototype.hasSearchOption = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string search_option_name = 2;
 * @return {string}
 */
proto.scout.candidate.v1.CreateSearchOptionRequest.prototype.getSearchOptionName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CreateSearchOptionRequest} returns this
 */
proto.scout.candidate.v1.CreateSearchOptionRequest.prototype.setSearchOptionName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.CreateSearchOptionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.CreateSearchOptionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.CreateSearchOptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CreateSearchOptionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.CreateSearchOptionResponse}
 */
proto.scout.candidate.v1.CreateSearchOptionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.CreateSearchOptionResponse;
  return proto.scout.candidate.v1.CreateSearchOptionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.CreateSearchOptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.CreateSearchOptionResponse}
 */
proto.scout.candidate.v1.CreateSearchOptionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.CreateSearchOptionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.CreateSearchOptionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.CreateSearchOptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CreateSearchOptionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.CreateSearchOptionResponse.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.CreateSearchOptionResponse} returns this
 */
proto.scout.candidate.v1.CreateSearchOptionResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.scout.candidate.v1.ScoutCandidateDetail.repeatedFields_ = [3,4,5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.ScoutCandidateDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.ScoutCandidateDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.ScoutCandidateDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
profile: (f = msg.getProfile()) && proto.scout.candidate.v1.Profile.toObject(includeInstance, f),
coreOfJobHunting: (f = msg.getCoreOfJobHunting()) && proto.scout.candidate.v1.CoreOfJobHunting.toObject(includeInstance, f),
activitiesList: jspb.Message.toObjectList(msg.getActivitiesList(),
    proto.scout.candidate.v1.Activity.toObject, includeInstance),
internshipResultsList: jspb.Message.toObjectList(msg.getInternshipResultsList(),
    proto.scout.candidate.v1.InternshipResult.toObject, includeInstance),
programmingSkillsList: jspb.Message.toObjectList(msg.getProgrammingSkillsList(),
    proto.scout.candidate.v1.ProgrammingSkill.toObject, includeInstance),
languageAbilitiesList: jspb.Message.toObjectList(msg.getLanguageAbilitiesList(),
    proto.scout.candidate.v1.LanguageAbility.toObject, includeInstance),
studentEndeavor: (f = msg.getStudentEndeavor()) && proto.scout.candidate.v1.StudentEndeavor.toObject(includeInstance, f),
selfPromotion: (f = msg.getSelfPromotion()) && proto.scout.candidate.v1.SelfPromotion.toObject(includeInstance, f),
researchContent: (f = msg.getResearchContent()) && proto.scout.candidate.v1.ResearchContent.toObject(includeInstance, f),
seminarCircle: jspb.Message.getFieldWithDefault(msg, 10, ""),
careerVision: (f = msg.getCareerVision()) && proto.scout.candidate.v1.CareerVision.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.ScoutCandidateDetail;
  return proto.scout.candidate.v1.ScoutCandidateDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.ScoutCandidateDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.scout.candidate.v1.Profile;
      reader.readMessage(value,proto.scout.candidate.v1.Profile.deserializeBinaryFromReader);
      msg.setProfile(value);
      break;
    case 2:
      var value = new proto.scout.candidate.v1.CoreOfJobHunting;
      reader.readMessage(value,proto.scout.candidate.v1.CoreOfJobHunting.deserializeBinaryFromReader);
      msg.setCoreOfJobHunting(value);
      break;
    case 3:
      var value = new proto.scout.candidate.v1.Activity;
      reader.readMessage(value,proto.scout.candidate.v1.Activity.deserializeBinaryFromReader);
      msg.addActivities(value);
      break;
    case 4:
      var value = new proto.scout.candidate.v1.InternshipResult;
      reader.readMessage(value,proto.scout.candidate.v1.InternshipResult.deserializeBinaryFromReader);
      msg.addInternshipResults(value);
      break;
    case 5:
      var value = new proto.scout.candidate.v1.ProgrammingSkill;
      reader.readMessage(value,proto.scout.candidate.v1.ProgrammingSkill.deserializeBinaryFromReader);
      msg.addProgrammingSkills(value);
      break;
    case 6:
      var value = new proto.scout.candidate.v1.LanguageAbility;
      reader.readMessage(value,proto.scout.candidate.v1.LanguageAbility.deserializeBinaryFromReader);
      msg.addLanguageAbilities(value);
      break;
    case 7:
      var value = new proto.scout.candidate.v1.StudentEndeavor;
      reader.readMessage(value,proto.scout.candidate.v1.StudentEndeavor.deserializeBinaryFromReader);
      msg.setStudentEndeavor(value);
      break;
    case 8:
      var value = new proto.scout.candidate.v1.SelfPromotion;
      reader.readMessage(value,proto.scout.candidate.v1.SelfPromotion.deserializeBinaryFromReader);
      msg.setSelfPromotion(value);
      break;
    case 9:
      var value = new proto.scout.candidate.v1.ResearchContent;
      reader.readMessage(value,proto.scout.candidate.v1.ResearchContent.deserializeBinaryFromReader);
      msg.setResearchContent(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeminarCircle(value);
      break;
    case 11:
      var value = new proto.scout.candidate.v1.CareerVision;
      reader.readMessage(value,proto.scout.candidate.v1.CareerVision.deserializeBinaryFromReader);
      msg.setCareerVision(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.ScoutCandidateDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.ScoutCandidateDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.ScoutCandidateDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfile();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.scout.candidate.v1.Profile.serializeBinaryToWriter
    );
  }
  f = message.getCoreOfJobHunting();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.scout.candidate.v1.CoreOfJobHunting.serializeBinaryToWriter
    );
  }
  f = message.getActivitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.scout.candidate.v1.Activity.serializeBinaryToWriter
    );
  }
  f = message.getInternshipResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.scout.candidate.v1.InternshipResult.serializeBinaryToWriter
    );
  }
  f = message.getProgrammingSkillsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.scout.candidate.v1.ProgrammingSkill.serializeBinaryToWriter
    );
  }
  f = message.getLanguageAbilitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.scout.candidate.v1.LanguageAbility.serializeBinaryToWriter
    );
  }
  f = message.getStudentEndeavor();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.scout.candidate.v1.StudentEndeavor.serializeBinaryToWriter
    );
  }
  f = message.getSelfPromotion();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.scout.candidate.v1.SelfPromotion.serializeBinaryToWriter
    );
  }
  f = message.getResearchContent();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.scout.candidate.v1.ResearchContent.serializeBinaryToWriter
    );
  }
  f = message.getSeminarCircle();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCareerVision();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.scout.candidate.v1.CareerVision.serializeBinaryToWriter
    );
  }
};


/**
 * optional Profile profile = 1;
 * @return {?proto.scout.candidate.v1.Profile}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.getProfile = function() {
  return /** @type{?proto.scout.candidate.v1.Profile} */ (
    jspb.Message.getWrapperField(this, proto.scout.candidate.v1.Profile, 1));
};


/**
 * @param {?proto.scout.candidate.v1.Profile|undefined} value
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
*/
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.setProfile = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.clearProfile = function() {
  return this.setProfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.hasProfile = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CoreOfJobHunting core_of_job_hunting = 2;
 * @return {?proto.scout.candidate.v1.CoreOfJobHunting}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.getCoreOfJobHunting = function() {
  return /** @type{?proto.scout.candidate.v1.CoreOfJobHunting} */ (
    jspb.Message.getWrapperField(this, proto.scout.candidate.v1.CoreOfJobHunting, 2));
};


/**
 * @param {?proto.scout.candidate.v1.CoreOfJobHunting|undefined} value
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
*/
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.setCoreOfJobHunting = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.clearCoreOfJobHunting = function() {
  return this.setCoreOfJobHunting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.hasCoreOfJobHunting = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Activity activities = 3;
 * @return {!Array<!proto.scout.candidate.v1.Activity>}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.getActivitiesList = function() {
  return /** @type{!Array<!proto.scout.candidate.v1.Activity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.scout.candidate.v1.Activity, 3));
};


/**
 * @param {!Array<!proto.scout.candidate.v1.Activity>} value
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
*/
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.setActivitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.scout.candidate.v1.Activity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.Activity}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.addActivities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.scout.candidate.v1.Activity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.clearActivitiesList = function() {
  return this.setActivitiesList([]);
};


/**
 * repeated InternshipResult internship_results = 4;
 * @return {!Array<!proto.scout.candidate.v1.InternshipResult>}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.getInternshipResultsList = function() {
  return /** @type{!Array<!proto.scout.candidate.v1.InternshipResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.scout.candidate.v1.InternshipResult, 4));
};


/**
 * @param {!Array<!proto.scout.candidate.v1.InternshipResult>} value
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
*/
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.setInternshipResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.scout.candidate.v1.InternshipResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.InternshipResult}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.addInternshipResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.scout.candidate.v1.InternshipResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.clearInternshipResultsList = function() {
  return this.setInternshipResultsList([]);
};


/**
 * repeated ProgrammingSkill programming_skills = 5;
 * @return {!Array<!proto.scout.candidate.v1.ProgrammingSkill>}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.getProgrammingSkillsList = function() {
  return /** @type{!Array<!proto.scout.candidate.v1.ProgrammingSkill>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.scout.candidate.v1.ProgrammingSkill, 5));
};


/**
 * @param {!Array<!proto.scout.candidate.v1.ProgrammingSkill>} value
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
*/
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.setProgrammingSkillsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.scout.candidate.v1.ProgrammingSkill=} opt_value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.ProgrammingSkill}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.addProgrammingSkills = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.scout.candidate.v1.ProgrammingSkill, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.clearProgrammingSkillsList = function() {
  return this.setProgrammingSkillsList([]);
};


/**
 * repeated LanguageAbility language_abilities = 6;
 * @return {!Array<!proto.scout.candidate.v1.LanguageAbility>}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.getLanguageAbilitiesList = function() {
  return /** @type{!Array<!proto.scout.candidate.v1.LanguageAbility>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.scout.candidate.v1.LanguageAbility, 6));
};


/**
 * @param {!Array<!proto.scout.candidate.v1.LanguageAbility>} value
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
*/
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.setLanguageAbilitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.scout.candidate.v1.LanguageAbility=} opt_value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.LanguageAbility}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.addLanguageAbilities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.scout.candidate.v1.LanguageAbility, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.clearLanguageAbilitiesList = function() {
  return this.setLanguageAbilitiesList([]);
};


/**
 * optional StudentEndeavor student_endeavor = 7;
 * @return {?proto.scout.candidate.v1.StudentEndeavor}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.getStudentEndeavor = function() {
  return /** @type{?proto.scout.candidate.v1.StudentEndeavor} */ (
    jspb.Message.getWrapperField(this, proto.scout.candidate.v1.StudentEndeavor, 7));
};


/**
 * @param {?proto.scout.candidate.v1.StudentEndeavor|undefined} value
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
*/
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.setStudentEndeavor = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.clearStudentEndeavor = function() {
  return this.setStudentEndeavor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.hasStudentEndeavor = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional SelfPromotion self_promotion = 8;
 * @return {?proto.scout.candidate.v1.SelfPromotion}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.getSelfPromotion = function() {
  return /** @type{?proto.scout.candidate.v1.SelfPromotion} */ (
    jspb.Message.getWrapperField(this, proto.scout.candidate.v1.SelfPromotion, 8));
};


/**
 * @param {?proto.scout.candidate.v1.SelfPromotion|undefined} value
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
*/
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.setSelfPromotion = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.clearSelfPromotion = function() {
  return this.setSelfPromotion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.hasSelfPromotion = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional ResearchContent research_content = 9;
 * @return {?proto.scout.candidate.v1.ResearchContent}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.getResearchContent = function() {
  return /** @type{?proto.scout.candidate.v1.ResearchContent} */ (
    jspb.Message.getWrapperField(this, proto.scout.candidate.v1.ResearchContent, 9));
};


/**
 * @param {?proto.scout.candidate.v1.ResearchContent|undefined} value
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
*/
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.setResearchContent = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.clearResearchContent = function() {
  return this.setResearchContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.hasResearchContent = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string seminar_circle = 10;
 * @return {string}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.getSeminarCircle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.setSeminarCircle = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional CareerVision career_vision = 11;
 * @return {?proto.scout.candidate.v1.CareerVision}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.getCareerVision = function() {
  return /** @type{?proto.scout.candidate.v1.CareerVision} */ (
    jspb.Message.getWrapperField(this, proto.scout.candidate.v1.CareerVision, 11));
};


/**
 * @param {?proto.scout.candidate.v1.CareerVision|undefined} value
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
*/
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.setCareerVision = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scout.candidate.v1.ScoutCandidateDetail} returns this
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.clearCareerVision = function() {
  return this.setCareerVision(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.ScoutCandidateDetail.prototype.hasCareerVision = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.Profile.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.Profile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.Profile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.Profile.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
uniqueId: jspb.Message.getFieldWithDefault(msg, 2, ""),
universityName: jspb.Message.getFieldWithDefault(msg, 3, ""),
course: jspb.Message.getFieldWithDefault(msg, 4, ""),
department: jspb.Message.getFieldWithDefault(msg, 5, ""),
concentration: jspb.Message.getFieldWithDefault(msg, 6, ""),
grade: jspb.Message.getFieldWithDefault(msg, 7, ""),
graduateYear: jspb.Message.getFieldWithDefault(msg, 8, ""),
lastAccessAtMs: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
voted: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
highSchoolName: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.Profile}
 */
proto.scout.candidate.v1.Profile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.Profile;
  return proto.scout.candidate.v1.Profile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.Profile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.Profile}
 */
proto.scout.candidate.v1.Profile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUniqueId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUniversityName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCourse(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDepartment(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setConcentration(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setGrade(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setGraduateYear(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastAccessAtMs(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVoted(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setHighSchoolName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.Profile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.Profile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.Profile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.Profile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUniqueId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUniversityName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCourse();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDepartment();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getConcentration();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getGrade();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getGraduateYear();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getVoted();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getHighSchoolName();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional int64 user_id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.Profile.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.Profile} returns this
 */
proto.scout.candidate.v1.Profile.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string unique_id = 2;
 * @return {string}
 */
proto.scout.candidate.v1.Profile.prototype.getUniqueId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.Profile} returns this
 */
proto.scout.candidate.v1.Profile.prototype.setUniqueId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string university_name = 3;
 * @return {string}
 */
proto.scout.candidate.v1.Profile.prototype.getUniversityName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.Profile} returns this
 */
proto.scout.candidate.v1.Profile.prototype.setUniversityName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string course = 4;
 * @return {string}
 */
proto.scout.candidate.v1.Profile.prototype.getCourse = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.Profile} returns this
 */
proto.scout.candidate.v1.Profile.prototype.setCourse = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string department = 5;
 * @return {string}
 */
proto.scout.candidate.v1.Profile.prototype.getDepartment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.Profile} returns this
 */
proto.scout.candidate.v1.Profile.prototype.setDepartment = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string concentration = 6;
 * @return {string}
 */
proto.scout.candidate.v1.Profile.prototype.getConcentration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.Profile} returns this
 */
proto.scout.candidate.v1.Profile.prototype.setConcentration = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string grade = 7;
 * @return {string}
 */
proto.scout.candidate.v1.Profile.prototype.getGrade = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.Profile} returns this
 */
proto.scout.candidate.v1.Profile.prototype.setGrade = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string graduate_year = 8;
 * @return {string}
 */
proto.scout.candidate.v1.Profile.prototype.getGraduateYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.Profile} returns this
 */
proto.scout.candidate.v1.Profile.prototype.setGraduateYear = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 last_access_at_ms = 9;
 * @return {number}
 */
proto.scout.candidate.v1.Profile.prototype.getLastAccessAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.Profile} returns this
 */
proto.scout.candidate.v1.Profile.prototype.setLastAccessAtMs = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.scout.candidate.v1.Profile} returns this
 */
proto.scout.candidate.v1.Profile.prototype.clearLastAccessAtMs = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.Profile.prototype.hasLastAccessAtMs = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool voted = 10;
 * @return {boolean}
 */
proto.scout.candidate.v1.Profile.prototype.getVoted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scout.candidate.v1.Profile} returns this
 */
proto.scout.candidate.v1.Profile.prototype.setVoted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string high_school_name = 11;
 * @return {string}
 */
proto.scout.candidate.v1.Profile.prototype.getHighSchoolName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.Profile} returns this
 */
proto.scout.candidate.v1.Profile.prototype.setHighSchoolName = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.scout.candidate.v1.CoreOfJobHunting.repeatedFields_ = [1,2,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.CoreOfJobHunting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.CoreOfJobHunting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CoreOfJobHunting.toObject = function(includeInstance, msg) {
  var f, obj = {
aspiringBusinessCategoriesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
preferredWorkPrefecturesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
preferredJobTypesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
companyChoiceFactorsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.CoreOfJobHunting}
 */
proto.scout.candidate.v1.CoreOfJobHunting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.CoreOfJobHunting;
  return proto.scout.candidate.v1.CoreOfJobHunting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.CoreOfJobHunting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.CoreOfJobHunting}
 */
proto.scout.candidate.v1.CoreOfJobHunting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAspiringBusinessCategories(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addPreferredWorkPrefectures(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addPreferredJobTypes(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addCompanyChoiceFactors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.CoreOfJobHunting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.CoreOfJobHunting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CoreOfJobHunting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAspiringBusinessCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getPreferredWorkPrefecturesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getPreferredJobTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getCompanyChoiceFactorsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * repeated string aspiring_business_categories = 1;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.getAspiringBusinessCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CoreOfJobHunting} returns this
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.setAspiringBusinessCategoriesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CoreOfJobHunting} returns this
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.addAspiringBusinessCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CoreOfJobHunting} returns this
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.clearAspiringBusinessCategoriesList = function() {
  return this.setAspiringBusinessCategoriesList([]);
};


/**
 * repeated string preferred_work_prefectures = 2;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.getPreferredWorkPrefecturesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CoreOfJobHunting} returns this
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.setPreferredWorkPrefecturesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CoreOfJobHunting} returns this
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.addPreferredWorkPrefectures = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CoreOfJobHunting} returns this
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.clearPreferredWorkPrefecturesList = function() {
  return this.setPreferredWorkPrefecturesList([]);
};


/**
 * repeated string preferred_job_types = 3;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.getPreferredJobTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CoreOfJobHunting} returns this
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.setPreferredJobTypesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CoreOfJobHunting} returns this
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.addPreferredJobTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CoreOfJobHunting} returns this
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.clearPreferredJobTypesList = function() {
  return this.setPreferredJobTypesList([]);
};


/**
 * repeated string company_choice_factors = 4;
 * @return {!Array<string>}
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.getCompanyChoiceFactorsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.scout.candidate.v1.CoreOfJobHunting} returns this
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.setCompanyChoiceFactorsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CoreOfJobHunting} returns this
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.addCompanyChoiceFactors = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.CoreOfJobHunting} returns this
 */
proto.scout.candidate.v1.CoreOfJobHunting.prototype.clearCompanyChoiceFactorsList = function() {
  return this.setCompanyChoiceFactorsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.Activity.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.Activity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.Activity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.Activity.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
largeCategoryName: jspb.Message.getFieldWithDefault(msg, 2, ""),
mediumCategoryName: jspb.Message.getFieldWithDefault(msg, 3, ""),
description: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.Activity}
 */
proto.scout.candidate.v1.Activity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.Activity;
  return proto.scout.candidate.v1.Activity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.Activity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.Activity}
 */
proto.scout.candidate.v1.Activity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLargeCategoryName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMediumCategoryName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.Activity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.Activity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.Activity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.Activity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getLargeCategoryName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMediumCategoryName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.Activity.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.Activity} returns this
 */
proto.scout.candidate.v1.Activity.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string large_category_name = 2;
 * @return {string}
 */
proto.scout.candidate.v1.Activity.prototype.getLargeCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.Activity} returns this
 */
proto.scout.candidate.v1.Activity.prototype.setLargeCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string medium_category_name = 3;
 * @return {string}
 */
proto.scout.candidate.v1.Activity.prototype.getMediumCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.Activity} returns this
 */
proto.scout.candidate.v1.Activity.prototype.setMediumCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.scout.candidate.v1.Activity.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.Activity} returns this
 */
proto.scout.candidate.v1.Activity.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.InternshipResult.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.InternshipResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.InternshipResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.InternshipResult.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
jobCategory: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, ""),
course: jspb.Message.getFieldWithDefault(msg, 4, ""),
companyName: jspb.Message.getFieldWithDefault(msg, 5, ""),
startAtMs: jspb.Message.getFieldWithDefault(msg, 6, 0),
endAtMs: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.InternshipResult}
 */
proto.scout.candidate.v1.InternshipResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.InternshipResult;
  return proto.scout.candidate.v1.InternshipResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.InternshipResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.InternshipResult}
 */
proto.scout.candidate.v1.InternshipResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobCategory(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCourse(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyName(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartAtMs(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndAtMs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.InternshipResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.InternshipResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.InternshipResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.InternshipResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getJobCategory();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCourse();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCompanyName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStartAtMs();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getEndAtMs();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.InternshipResult.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.InternshipResult} returns this
 */
proto.scout.candidate.v1.InternshipResult.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string job_category = 2;
 * @return {string}
 */
proto.scout.candidate.v1.InternshipResult.prototype.getJobCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.InternshipResult} returns this
 */
proto.scout.candidate.v1.InternshipResult.prototype.setJobCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.scout.candidate.v1.InternshipResult.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.InternshipResult} returns this
 */
proto.scout.candidate.v1.InternshipResult.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string course = 4;
 * @return {string}
 */
proto.scout.candidate.v1.InternshipResult.prototype.getCourse = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.InternshipResult} returns this
 */
proto.scout.candidate.v1.InternshipResult.prototype.setCourse = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string company_name = 5;
 * @return {string}
 */
proto.scout.candidate.v1.InternshipResult.prototype.getCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.InternshipResult} returns this
 */
proto.scout.candidate.v1.InternshipResult.prototype.setCompanyName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 start_at_ms = 6;
 * @return {number}
 */
proto.scout.candidate.v1.InternshipResult.prototype.getStartAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.InternshipResult} returns this
 */
proto.scout.candidate.v1.InternshipResult.prototype.setStartAtMs = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 end_at_ms = 7;
 * @return {number}
 */
proto.scout.candidate.v1.InternshipResult.prototype.getEndAtMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.InternshipResult} returns this
 */
proto.scout.candidate.v1.InternshipResult.prototype.setEndAtMs = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.ProgrammingSkill.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.ProgrammingSkill.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.ProgrammingSkill} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.ProgrammingSkill.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.ProgrammingSkill}
 */
proto.scout.candidate.v1.ProgrammingSkill.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.ProgrammingSkill;
  return proto.scout.candidate.v1.ProgrammingSkill.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.ProgrammingSkill} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.ProgrammingSkill}
 */
proto.scout.candidate.v1.ProgrammingSkill.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.ProgrammingSkill.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.ProgrammingSkill.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.ProgrammingSkill} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.ProgrammingSkill.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.ProgrammingSkill.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.ProgrammingSkill} returns this
 */
proto.scout.candidate.v1.ProgrammingSkill.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.scout.candidate.v1.ProgrammingSkill.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.ProgrammingSkill} returns this
 */
proto.scout.candidate.v1.ProgrammingSkill.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.scout.candidate.v1.ProgrammingSkill.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.ProgrammingSkill} returns this
 */
proto.scout.candidate.v1.ProgrammingSkill.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.LanguageAbility.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.LanguageAbility.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.LanguageAbility} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.LanguageAbility.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
level: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.LanguageAbility}
 */
proto.scout.candidate.v1.LanguageAbility.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.LanguageAbility;
  return proto.scout.candidate.v1.LanguageAbility.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.LanguageAbility} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.LanguageAbility}
 */
proto.scout.candidate.v1.LanguageAbility.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLevel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.LanguageAbility.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.LanguageAbility.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.LanguageAbility} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.LanguageAbility.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLevel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.LanguageAbility.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.LanguageAbility} returns this
 */
proto.scout.candidate.v1.LanguageAbility.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.scout.candidate.v1.LanguageAbility.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.LanguageAbility} returns this
 */
proto.scout.candidate.v1.LanguageAbility.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string level = 3;
 * @return {string}
 */
proto.scout.candidate.v1.LanguageAbility.prototype.getLevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.LanguageAbility} returns this
 */
proto.scout.candidate.v1.LanguageAbility.prototype.setLevel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.StudentEndeavor.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.StudentEndeavor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.StudentEndeavor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.StudentEndeavor.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
content: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.StudentEndeavor}
 */
proto.scout.candidate.v1.StudentEndeavor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.StudentEndeavor;
  return proto.scout.candidate.v1.StudentEndeavor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.StudentEndeavor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.StudentEndeavor}
 */
proto.scout.candidate.v1.StudentEndeavor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.StudentEndeavor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.StudentEndeavor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.StudentEndeavor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.StudentEndeavor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.StudentEndeavor.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.StudentEndeavor} returns this
 */
proto.scout.candidate.v1.StudentEndeavor.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string content = 2;
 * @return {string}
 */
proto.scout.candidate.v1.StudentEndeavor.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.StudentEndeavor} returns this
 */
proto.scout.candidate.v1.StudentEndeavor.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.SelfPromotion.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.SelfPromotion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.SelfPromotion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.SelfPromotion.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
content: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.SelfPromotion}
 */
proto.scout.candidate.v1.SelfPromotion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.SelfPromotion;
  return proto.scout.candidate.v1.SelfPromotion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.SelfPromotion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.SelfPromotion}
 */
proto.scout.candidate.v1.SelfPromotion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.SelfPromotion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.SelfPromotion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.SelfPromotion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.SelfPromotion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.SelfPromotion.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.SelfPromotion} returns this
 */
proto.scout.candidate.v1.SelfPromotion.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string content = 2;
 * @return {string}
 */
proto.scout.candidate.v1.SelfPromotion.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.SelfPromotion} returns this
 */
proto.scout.candidate.v1.SelfPromotion.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.ResearchContent.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.ResearchContent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.ResearchContent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.ResearchContent.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
content: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.ResearchContent}
 */
proto.scout.candidate.v1.ResearchContent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.ResearchContent;
  return proto.scout.candidate.v1.ResearchContent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.ResearchContent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.ResearchContent}
 */
proto.scout.candidate.v1.ResearchContent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.ResearchContent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.ResearchContent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.ResearchContent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.ResearchContent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.ResearchContent.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.ResearchContent} returns this
 */
proto.scout.candidate.v1.ResearchContent.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string content = 2;
 * @return {string}
 */
proto.scout.candidate.v1.ResearchContent.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.ResearchContent} returns this
 */
proto.scout.candidate.v1.ResearchContent.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.CareerVision.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.CareerVision.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.CareerVision} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CareerVision.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
content: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.CareerVision}
 */
proto.scout.candidate.v1.CareerVision.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.CareerVision;
  return proto.scout.candidate.v1.CareerVision.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.CareerVision} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.CareerVision}
 */
proto.scout.candidate.v1.CareerVision.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.CareerVision.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.CareerVision.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.CareerVision} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CareerVision.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.CareerVision.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.CareerVision} returns this
 */
proto.scout.candidate.v1.CareerVision.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string content = 2;
 * @return {string}
 */
proto.scout.candidate.v1.CareerVision.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.CareerVision} returns this
 */
proto.scout.candidate.v1.CareerVision.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.SavedCandidateSearchOption.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.SavedCandidateSearchOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.SavedCandidateSearchOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.SavedCandidateSearchOption.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.SavedCandidateSearchOption}
 */
proto.scout.candidate.v1.SavedCandidateSearchOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.SavedCandidateSearchOption;
  return proto.scout.candidate.v1.SavedCandidateSearchOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.SavedCandidateSearchOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.SavedCandidateSearchOption}
 */
proto.scout.candidate.v1.SavedCandidateSearchOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.SavedCandidateSearchOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.SavedCandidateSearchOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.SavedCandidateSearchOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.SavedCandidateSearchOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.SavedCandidateSearchOption.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.SavedCandidateSearchOption} returns this
 */
proto.scout.candidate.v1.SavedCandidateSearchOption.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.scout.candidate.v1.SavedCandidateSearchOption.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.SavedCandidateSearchOption} returns this
 */
proto.scout.candidate.v1.SavedCandidateSearchOption.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest}
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest;
  return proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest}
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
savedCandidateSearchOptionsList: jspb.Message.toObjectList(msg.getSavedCandidateSearchOptionsList(),
    proto.scout.candidate.v1.SavedCandidateSearchOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse}
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse;
  return proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse}
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.scout.candidate.v1.SavedCandidateSearchOption;
      reader.readMessage(value,proto.scout.candidate.v1.SavedCandidateSearchOption.deserializeBinaryFromReader);
      msg.addSavedCandidateSearchOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSavedCandidateSearchOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.scout.candidate.v1.SavedCandidateSearchOption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SavedCandidateSearchOption saved_candidate_search_options = 1;
 * @return {!Array<!proto.scout.candidate.v1.SavedCandidateSearchOption>}
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.prototype.getSavedCandidateSearchOptionsList = function() {
  return /** @type{!Array<!proto.scout.candidate.v1.SavedCandidateSearchOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.scout.candidate.v1.SavedCandidateSearchOption, 1));
};


/**
 * @param {!Array<!proto.scout.candidate.v1.SavedCandidateSearchOption>} value
 * @return {!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse} returns this
*/
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.prototype.setSavedCandidateSearchOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.scout.candidate.v1.SavedCandidateSearchOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.SavedCandidateSearchOption}
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.prototype.addSavedCandidateSearchOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.scout.candidate.v1.SavedCandidateSearchOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse} returns this
 */
proto.scout.candidate.v1.GetAllSearchOptionsOrderByUpdatedAtResponse.prototype.clearSavedCandidateSearchOptionsList = function() {
  return this.setSavedCandidateSearchOptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.GetSearchOptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.GetSearchOptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.GetSearchOptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.GetSearchOptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.GetSearchOptionRequest}
 */
proto.scout.candidate.v1.GetSearchOptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.GetSearchOptionRequest;
  return proto.scout.candidate.v1.GetSearchOptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.GetSearchOptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.GetSearchOptionRequest}
 */
proto.scout.candidate.v1.GetSearchOptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.GetSearchOptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.GetSearchOptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.GetSearchOptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.GetSearchOptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.GetSearchOptionRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.GetSearchOptionRequest} returns this
 */
proto.scout.candidate.v1.GetSearchOptionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.SavedCandidateSearchOptionDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
searchOption: (f = msg.getSearchOption()) && proto.scout.candidate.v1.CandidateSearchOption.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.SavedCandidateSearchOptionDetail}
 */
proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.SavedCandidateSearchOptionDetail;
  return proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.SavedCandidateSearchOptionDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.SavedCandidateSearchOptionDetail}
 */
proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.scout.candidate.v1.CandidateSearchOption;
      reader.readMessage(value,proto.scout.candidate.v1.CandidateSearchOption.deserializeBinaryFromReader);
      msg.setSearchOption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.SavedCandidateSearchOptionDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSearchOption();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.scout.candidate.v1.CandidateSearchOption.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.SavedCandidateSearchOptionDetail} returns this
 */
proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.SavedCandidateSearchOptionDetail} returns this
 */
proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional CandidateSearchOption search_option = 3;
 * @return {?proto.scout.candidate.v1.CandidateSearchOption}
 */
proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.prototype.getSearchOption = function() {
  return /** @type{?proto.scout.candidate.v1.CandidateSearchOption} */ (
    jspb.Message.getWrapperField(this, proto.scout.candidate.v1.CandidateSearchOption, 3));
};


/**
 * @param {?proto.scout.candidate.v1.CandidateSearchOption|undefined} value
 * @return {!proto.scout.candidate.v1.SavedCandidateSearchOptionDetail} returns this
*/
proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.prototype.setSearchOption = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scout.candidate.v1.SavedCandidateSearchOptionDetail} returns this
 */
proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.prototype.clearSearchOption = function() {
  return this.setSearchOption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.prototype.hasSearchOption = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.GetSearchOptionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.GetSearchOptionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.GetSearchOptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.GetSearchOptionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
detail: (f = msg.getDetail()) && proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.GetSearchOptionResponse}
 */
proto.scout.candidate.v1.GetSearchOptionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.GetSearchOptionResponse;
  return proto.scout.candidate.v1.GetSearchOptionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.GetSearchOptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.GetSearchOptionResponse}
 */
proto.scout.candidate.v1.GetSearchOptionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.scout.candidate.v1.SavedCandidateSearchOptionDetail;
      reader.readMessage(value,proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.deserializeBinaryFromReader);
      msg.setDetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.GetSearchOptionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.GetSearchOptionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.GetSearchOptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.GetSearchOptionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDetail();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.scout.candidate.v1.SavedCandidateSearchOptionDetail.serializeBinaryToWriter
    );
  }
};


/**
 * optional SavedCandidateSearchOptionDetail detail = 1;
 * @return {?proto.scout.candidate.v1.SavedCandidateSearchOptionDetail}
 */
proto.scout.candidate.v1.GetSearchOptionResponse.prototype.getDetail = function() {
  return /** @type{?proto.scout.candidate.v1.SavedCandidateSearchOptionDetail} */ (
    jspb.Message.getWrapperField(this, proto.scout.candidate.v1.SavedCandidateSearchOptionDetail, 1));
};


/**
 * @param {?proto.scout.candidate.v1.SavedCandidateSearchOptionDetail|undefined} value
 * @return {!proto.scout.candidate.v1.GetSearchOptionResponse} returns this
*/
proto.scout.candidate.v1.GetSearchOptionResponse.prototype.setDetail = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scout.candidate.v1.GetSearchOptionResponse} returns this
 */
proto.scout.candidate.v1.GetSearchOptionResponse.prototype.clearDetail = function() {
  return this.setDetail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.GetSearchOptionResponse.prototype.hasDetail = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.UpdateSearchOptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.UpdateSearchOptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.UpdateSearchOptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.UpdateSearchOptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
searchOption: (f = msg.getSearchOption()) && proto.scout.candidate.v1.CandidateSearchOption.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.UpdateSearchOptionRequest}
 */
proto.scout.candidate.v1.UpdateSearchOptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.UpdateSearchOptionRequest;
  return proto.scout.candidate.v1.UpdateSearchOptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.UpdateSearchOptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.UpdateSearchOptionRequest}
 */
proto.scout.candidate.v1.UpdateSearchOptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.scout.candidate.v1.CandidateSearchOption;
      reader.readMessage(value,proto.scout.candidate.v1.CandidateSearchOption.deserializeBinaryFromReader);
      msg.setSearchOption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.UpdateSearchOptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.UpdateSearchOptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.UpdateSearchOptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.UpdateSearchOptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSearchOption();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.scout.candidate.v1.CandidateSearchOption.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.UpdateSearchOptionRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.UpdateSearchOptionRequest} returns this
 */
proto.scout.candidate.v1.UpdateSearchOptionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional CandidateSearchOption search_option = 2;
 * @return {?proto.scout.candidate.v1.CandidateSearchOption}
 */
proto.scout.candidate.v1.UpdateSearchOptionRequest.prototype.getSearchOption = function() {
  return /** @type{?proto.scout.candidate.v1.CandidateSearchOption} */ (
    jspb.Message.getWrapperField(this, proto.scout.candidate.v1.CandidateSearchOption, 2));
};


/**
 * @param {?proto.scout.candidate.v1.CandidateSearchOption|undefined} value
 * @return {!proto.scout.candidate.v1.UpdateSearchOptionRequest} returns this
*/
proto.scout.candidate.v1.UpdateSearchOptionRequest.prototype.setSearchOption = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scout.candidate.v1.UpdateSearchOptionRequest} returns this
 */
proto.scout.candidate.v1.UpdateSearchOptionRequest.prototype.clearSearchOption = function() {
  return this.setSearchOption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.UpdateSearchOptionRequest.prototype.hasSearchOption = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.UpdateSearchOptionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.UpdateSearchOptionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.UpdateSearchOptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.UpdateSearchOptionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.UpdateSearchOptionResponse}
 */
proto.scout.candidate.v1.UpdateSearchOptionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.UpdateSearchOptionResponse;
  return proto.scout.candidate.v1.UpdateSearchOptionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.UpdateSearchOptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.UpdateSearchOptionResponse}
 */
proto.scout.candidate.v1.UpdateSearchOptionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.UpdateSearchOptionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.UpdateSearchOptionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.UpdateSearchOptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.UpdateSearchOptionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.UpdateSearchOptionNameRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.UpdateSearchOptionNameRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.UpdateSearchOptionNameRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.UpdateSearchOptionNameRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.UpdateSearchOptionNameRequest}
 */
proto.scout.candidate.v1.UpdateSearchOptionNameRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.UpdateSearchOptionNameRequest;
  return proto.scout.candidate.v1.UpdateSearchOptionNameRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.UpdateSearchOptionNameRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.UpdateSearchOptionNameRequest}
 */
proto.scout.candidate.v1.UpdateSearchOptionNameRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.UpdateSearchOptionNameRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.UpdateSearchOptionNameRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.UpdateSearchOptionNameRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.UpdateSearchOptionNameRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.UpdateSearchOptionNameRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.UpdateSearchOptionNameRequest} returns this
 */
proto.scout.candidate.v1.UpdateSearchOptionNameRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.scout.candidate.v1.UpdateSearchOptionNameRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.scout.candidate.v1.UpdateSearchOptionNameRequest} returns this
 */
proto.scout.candidate.v1.UpdateSearchOptionNameRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.UpdateSearchOptionNameResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.UpdateSearchOptionNameResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.UpdateSearchOptionNameResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.UpdateSearchOptionNameResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.UpdateSearchOptionNameResponse}
 */
proto.scout.candidate.v1.UpdateSearchOptionNameResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.UpdateSearchOptionNameResponse;
  return proto.scout.candidate.v1.UpdateSearchOptionNameResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.UpdateSearchOptionNameResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.UpdateSearchOptionNameResponse}
 */
proto.scout.candidate.v1.UpdateSearchOptionNameResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.UpdateSearchOptionNameResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.UpdateSearchOptionNameResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.UpdateSearchOptionNameResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.UpdateSearchOptionNameResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.DeleteSearchOptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.DeleteSearchOptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.DeleteSearchOptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.DeleteSearchOptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.DeleteSearchOptionRequest}
 */
proto.scout.candidate.v1.DeleteSearchOptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.DeleteSearchOptionRequest;
  return proto.scout.candidate.v1.DeleteSearchOptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.DeleteSearchOptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.DeleteSearchOptionRequest}
 */
proto.scout.candidate.v1.DeleteSearchOptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.DeleteSearchOptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.DeleteSearchOptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.DeleteSearchOptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.DeleteSearchOptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.scout.candidate.v1.DeleteSearchOptionRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.DeleteSearchOptionRequest} returns this
 */
proto.scout.candidate.v1.DeleteSearchOptionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.DeleteSearchOptionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.DeleteSearchOptionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.DeleteSearchOptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.DeleteSearchOptionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.DeleteSearchOptionResponse}
 */
proto.scout.candidate.v1.DeleteSearchOptionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.DeleteSearchOptionResponse;
  return proto.scout.candidate.v1.DeleteSearchOptionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.DeleteSearchOptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.DeleteSearchOptionResponse}
 */
proto.scout.candidate.v1.DeleteSearchOptionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.DeleteSearchOptionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.DeleteSearchOptionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.DeleteSearchOptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.DeleteSearchOptionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.SearchForAgentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.SearchForAgentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.SearchForAgentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.SearchForAgentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
searchOption: (f = msg.getSearchOption()) && proto.scout.candidate.v1.CandidateSearchOption.toObject(includeInstance, f),
sortKey: jspb.Message.getFieldWithDefault(msg, 2, 0),
sortOrder: jspb.Message.getFieldWithDefault(msg, 3, 0),
page: jspb.Message.getFieldWithDefault(msg, 4, 0),
per: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.SearchForAgentRequest}
 */
proto.scout.candidate.v1.SearchForAgentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.SearchForAgentRequest;
  return proto.scout.candidate.v1.SearchForAgentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.SearchForAgentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.SearchForAgentRequest}
 */
proto.scout.candidate.v1.SearchForAgentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.scout.candidate.v1.CandidateSearchOption;
      reader.readMessage(value,proto.scout.candidate.v1.CandidateSearchOption.deserializeBinaryFromReader);
      msg.setSearchOption(value);
      break;
    case 2:
      var value = /** @type {!proto.scout.candidate.v1.CandidateSortKey} */ (reader.readEnum());
      msg.setSortKey(value);
      break;
    case 3:
      var value = /** @type {!proto.scout.candidate.v1.CandidateSortOrder} */ (reader.readEnum());
      msg.setSortOrder(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.SearchForAgentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.SearchForAgentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.SearchForAgentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.SearchForAgentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSearchOption();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.scout.candidate.v1.CandidateSearchOption.serializeBinaryToWriter
    );
  }
  f = message.getSortKey();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSortOrder();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getPer();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional CandidateSearchOption search_option = 1;
 * @return {?proto.scout.candidate.v1.CandidateSearchOption}
 */
proto.scout.candidate.v1.SearchForAgentRequest.prototype.getSearchOption = function() {
  return /** @type{?proto.scout.candidate.v1.CandidateSearchOption} */ (
    jspb.Message.getWrapperField(this, proto.scout.candidate.v1.CandidateSearchOption, 1));
};


/**
 * @param {?proto.scout.candidate.v1.CandidateSearchOption|undefined} value
 * @return {!proto.scout.candidate.v1.SearchForAgentRequest} returns this
*/
proto.scout.candidate.v1.SearchForAgentRequest.prototype.setSearchOption = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scout.candidate.v1.SearchForAgentRequest} returns this
 */
proto.scout.candidate.v1.SearchForAgentRequest.prototype.clearSearchOption = function() {
  return this.setSearchOption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.SearchForAgentRequest.prototype.hasSearchOption = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CandidateSortKey sort_key = 2;
 * @return {!proto.scout.candidate.v1.CandidateSortKey}
 */
proto.scout.candidate.v1.SearchForAgentRequest.prototype.getSortKey = function() {
  return /** @type {!proto.scout.candidate.v1.CandidateSortKey} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.scout.candidate.v1.CandidateSortKey} value
 * @return {!proto.scout.candidate.v1.SearchForAgentRequest} returns this
 */
proto.scout.candidate.v1.SearchForAgentRequest.prototype.setSortKey = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional CandidateSortOrder sort_order = 3;
 * @return {!proto.scout.candidate.v1.CandidateSortOrder}
 */
proto.scout.candidate.v1.SearchForAgentRequest.prototype.getSortOrder = function() {
  return /** @type {!proto.scout.candidate.v1.CandidateSortOrder} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.scout.candidate.v1.CandidateSortOrder} value
 * @return {!proto.scout.candidate.v1.SearchForAgentRequest} returns this
 */
proto.scout.candidate.v1.SearchForAgentRequest.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 page = 4;
 * @return {number}
 */
proto.scout.candidate.v1.SearchForAgentRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.SearchForAgentRequest} returns this
 */
proto.scout.candidate.v1.SearchForAgentRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 per = 5;
 * @return {number}
 */
proto.scout.candidate.v1.SearchForAgentRequest.prototype.getPer = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.SearchForAgentRequest} returns this
 */
proto.scout.candidate.v1.SearchForAgentRequest.prototype.setPer = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.scout.candidate.v1.SearchForAgentResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.SearchForAgentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.SearchForAgentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.SearchForAgentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.SearchForAgentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
usersList: jspb.Message.toObjectList(msg.getUsersList(),
    proto.scout.candidate.v1.CandidateUser.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.SearchForAgentResponse}
 */
proto.scout.candidate.v1.SearchForAgentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.SearchForAgentResponse;
  return proto.scout.candidate.v1.SearchForAgentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.SearchForAgentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.SearchForAgentResponse}
 */
proto.scout.candidate.v1.SearchForAgentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.scout.candidate.v1.CandidateUser;
      reader.readMessage(value,proto.scout.candidate.v1.CandidateUser.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.SearchForAgentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.SearchForAgentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.SearchForAgentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.SearchForAgentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.scout.candidate.v1.CandidateUser.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CandidateUser users = 1;
 * @return {!Array<!proto.scout.candidate.v1.CandidateUser>}
 */
proto.scout.candidate.v1.SearchForAgentResponse.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.scout.candidate.v1.CandidateUser>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.scout.candidate.v1.CandidateUser, 1));
};


/**
 * @param {!Array<!proto.scout.candidate.v1.CandidateUser>} value
 * @return {!proto.scout.candidate.v1.SearchForAgentResponse} returns this
*/
proto.scout.candidate.v1.SearchForAgentResponse.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.scout.candidate.v1.CandidateUser=} opt_value
 * @param {number=} opt_index
 * @return {!proto.scout.candidate.v1.CandidateUser}
 */
proto.scout.candidate.v1.SearchForAgentResponse.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.scout.candidate.v1.CandidateUser, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.scout.candidate.v1.SearchForAgentResponse} returns this
 */
proto.scout.candidate.v1.SearchForAgentResponse.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.CountForAgentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.CountForAgentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.CountForAgentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CountForAgentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
searchOption: (f = msg.getSearchOption()) && proto.scout.candidate.v1.CandidateSearchOption.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.CountForAgentRequest}
 */
proto.scout.candidate.v1.CountForAgentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.CountForAgentRequest;
  return proto.scout.candidate.v1.CountForAgentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.CountForAgentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.CountForAgentRequest}
 */
proto.scout.candidate.v1.CountForAgentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.scout.candidate.v1.CandidateSearchOption;
      reader.readMessage(value,proto.scout.candidate.v1.CandidateSearchOption.deserializeBinaryFromReader);
      msg.setSearchOption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.CountForAgentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.CountForAgentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.CountForAgentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CountForAgentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSearchOption();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.scout.candidate.v1.CandidateSearchOption.serializeBinaryToWriter
    );
  }
};


/**
 * optional CandidateSearchOption search_option = 1;
 * @return {?proto.scout.candidate.v1.CandidateSearchOption}
 */
proto.scout.candidate.v1.CountForAgentRequest.prototype.getSearchOption = function() {
  return /** @type{?proto.scout.candidate.v1.CandidateSearchOption} */ (
    jspb.Message.getWrapperField(this, proto.scout.candidate.v1.CandidateSearchOption, 1));
};


/**
 * @param {?proto.scout.candidate.v1.CandidateSearchOption|undefined} value
 * @return {!proto.scout.candidate.v1.CountForAgentRequest} returns this
*/
proto.scout.candidate.v1.CountForAgentRequest.prototype.setSearchOption = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scout.candidate.v1.CountForAgentRequest} returns this
 */
proto.scout.candidate.v1.CountForAgentRequest.prototype.clearSearchOption = function() {
  return this.setSearchOption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scout.candidate.v1.CountForAgentRequest.prototype.hasSearchOption = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scout.candidate.v1.CountForAgentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.scout.candidate.v1.CountForAgentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scout.candidate.v1.CountForAgentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CountForAgentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
count: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scout.candidate.v1.CountForAgentResponse}
 */
proto.scout.candidate.v1.CountForAgentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scout.candidate.v1.CountForAgentResponse;
  return proto.scout.candidate.v1.CountForAgentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scout.candidate.v1.CountForAgentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scout.candidate.v1.CountForAgentResponse}
 */
proto.scout.candidate.v1.CountForAgentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scout.candidate.v1.CountForAgentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scout.candidate.v1.CountForAgentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scout.candidate.v1.CountForAgentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scout.candidate.v1.CountForAgentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 count = 1;
 * @return {number}
 */
proto.scout.candidate.v1.CountForAgentResponse.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.scout.candidate.v1.CountForAgentResponse} returns this
 */
proto.scout.candidate.v1.CountForAgentResponse.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.scout.candidate.v1.CandidateSortKey = {
  CANDIDATE_SORT_KEY_UNSPECIFIED: 0,
  CANDIDATE_SORT_KEY_LAST_ACCESS_AT: 1,
  CANDIDATE_SORT_KEY_MEMBER_REGISTRATION_AT: 2,
  CANDIDATE_SORT_KEY_MEMBER_INFO_UPDATED_AT: 3,
  CANDIDATE_SORT_KEY_ACTIVITIES_COUNT: 4
};

/**
 * @enum {number}
 */
proto.scout.candidate.v1.CandidateSortOrder = {
  CANDIDATE_SORT_ORDER_UNSPECIFIED: 0,
  CANDIDATE_SORT_ORDER_DESC: 1,
  CANDIDATE_SORT_ORDER_ASC: 2
};

/**
 * @enum {number}
 */
proto.scout.candidate.v1.CandidateLastAccessRange = {
  CANDIDATE_LAST_ACCESS_RANGE_UNSPECIFIED: 0,
  CANDIDATE_LAST_ACCESS_RANGE_30_MIN: 1,
  CANDIDATE_LAST_ACCESS_RANGE_1_HOUR: 2,
  CANDIDATE_LAST_ACCESS_RANGE_1_DAY: 3,
  CANDIDATE_LAST_ACCESS_RANGE_1_WEEK: 4,
  CANDIDATE_LAST_ACCESS_RANGE_1_MONTH: 5
};

goog.object.extend(exports, proto.scout.candidate.v1);
